// ProtectedRoute — redirects unauthenticated users to /login.
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { ForcePasswordChange } from "../pages/ForcePasswordChange";

export const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
  const location = useLocation();

  // null = checking session, false = anonymous, object = signed in
  if (user === null) {
    return (
      <div
        className="min-h-screen flex items-center justify-center"
        style={{ background: "#08090d" }}
        data-testid="auth-loading"
      >
        <div
          style={{
            fontFamily: "'DM Mono', monospace",
            fontSize: 11,
            color: "#9198b0",
            letterSpacing: "1.5px",
          }}
        >
          AUTHENTICATING…
        </div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  }
  // Iter79 — forced-password-change gate. While the flag is set, every
  // protected route renders the password-change screen instead of the app.
  if (user?.must_change_password) {
    return <ForcePasswordChange />;
  }
  // Phase B — Customer-tier auto-routing. Customer users only ever see the
  // /portal/* shell. Any attempt to reach a forwarder-side route lands them
  // on /portal/my-requests. Platform admins are exempt (they need full app
  // access for testing + management).
  const isCustomer = user?.tenant_type === "customer" && user?.role !== "platform_admin";
  if (isCustomer && !location.pathname.startsWith("/portal")) {
    return <Navigate to="/portal/my-requests" replace />;
  }
  // If a non-customer tries to access /portal/*, send them home (the portal
  // shell is for customer-tier only).
  if (!isCustomer && location.pathname.startsWith("/portal")) {
    return <Navigate to="/" replace />;
  }
  return children;
};
